module.exports = __webpack_public_path__ + "img/picture_05.1aafb7b4.png";